import React from 'react'
import './style.css'
const index = () => {
    let frameStyle={
        width: '100%',
        marginBottom: '3rem',
        border: '0',
        transform: 'scale(1)',
        overflow: 'hidden'
    }
  return (
    <div className="component-desc">
            <h2 className="heading">Image</h2>
            <div className="description">Images are used to make the website visually appealing and the user experience great. </div>
            <div className="divider"></div>
            <h4 className="heading">Responsive Images</h4>
            <div className="img-container">
                <img className="img-responsive" src="/images/sample1.jpg" alt="" />
                <img className="img-responsive" src="/images/sample2.jpg" alt="" />
            </div>

            <div className="carbon-container">
                <iframe
                    src="https://carbon.now.sh/embed?bg=rgba%28255%2C255%2C255%2C0%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14.5px&lh=133%25&si=false&es=2x&wm=false&code=%253Cimg%2520class%253D%2522img-responsive%2522%2520src%253D%2522.%252Fstatic%252Fimages%252Fsample-image.jpg%2522%2520alt%253D%2522%2522%253E"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>

            <div className="divider"></div>
            <h4 className="heading">Circular Images:</h4>
            <div style={{alignSelf:'center'}}>
                <img className="img-circular img-small" src="/images/sample2.jpg" alt="" />
                <img className="img-circular img-medium" src="/images/sample2.jpg" alt="" />
                <img className="img-circular img-large" src="/images/sample2.jpg" alt="" />  
            </div>

            <div className="carbon-container">
                <iframe
                    src="https://carbon.now.sh/embed?bg=rgba%28255%2C255%2C255%2C0%29&t=blackboard&wt=none&l=javascript&ds=false&dsyoff=20px&dsblur=68px&wc=true&wa=true&pv=0px&ph=0px&ln=false&fl=1&fm=Hack&fs=14.5px&lh=133%25&si=false&es=2x&wm=false&code=%252F*%2520circular%2520small%2520image%2520*%252F%250A%253Cimg%2520class%253D%2522img-circular%2520img-small%2522%2520src%253D%2522.%252Fstatic%252Fimages%252Fsample-image.jpg%2522%2520alt%253D%2522%2522%253E%250A%2520%2520%250A%252F*%2520circular%2520medium%2520image%2520*%252F%250A%253Cimg%2520class%253D%2522img-circular%2520img-medium%2522%2520src%253D%2522.%252Fstatic%252Fimages%252Fsample-image.jpg%2522%2520alt%253D%2522%2522%253E%250A%2520%250A%252F*%2520circular%2520large%2520image%2520*%252F%250A%253Cimg%2520class%253D%2522img-circular%2520img-large%2522%2520src%253D%2522.%252Fstatic%252Fimages%252Fsample-image.jpg%2522%2520alt%253D%2522%2522%253E%2520%2520"
                    style={frameStyle}
                    sandbox="allow-scripts allow-same-origin">
                </iframe>
            </div>
        </div>
  )
}

export default index